/* global BigInt */
/* eslint-disable no-unused-expressions */

const satBox = () => {
  "use strict";
  var t = {
      324: (t, e) => {
        Object.defineProperty(e, "__esModule", { value: !0 }),
          (e.EPOCH_SATS =
            e.COINBASE_MATURITY =
            e.MAX_SCRIPTNUM_VALUE =
            e.SUBSIDY_HALVING_INTERVAL =
            e.MAX_SCRIPT_ELEMENT_SIZE =
            e.SCRIPT_ADDRESS_PREFIX_TEST =
            e.PUBKEY_ADDRESS_PREFIX_TEST =
            e.SCRIPT_ADDRESS_PREFIX_MAIN =
            e.PUBKEY_ADDRESS_PREFIX_MAIN =
            e.MAX_BLOCK_SIGOPS_COST =
            e.WITNESS_SCALE_FACTOR =
            e.MIN_TRANSACTION_WEIGHT =
            e.MAX_BLOCK_WEIGHT =
            e.DIFFCHANGE_TIMESPAN =
            e.DIFFCHANGE_INTERVAL =
            e.TARGET_BLOCK_SPACING =
            e.HALVING_INTERVAL =
            e.COIN_VALUE =
            e.SAT_LAST =
            e.SAT_SUPPLY =
            e.CYCLE_EPOCHS =
            e.SAT_PAGE_LEN =
              void 0),
          (e.SAT_PAGE_LEN = 2e3),
          (e.CYCLE_EPOCHS = 6),
          (e.SAT_SUPPLY = 2099999997690000n),
          (e.SAT_LAST = 2099999997689999n),
          (e.COIN_VALUE = 100000000n),
          (e.HALVING_INTERVAL = 210000n),
          (e.TARGET_BLOCK_SPACING = 600),
          (e.DIFFCHANGE_INTERVAL = 2016),
          (e.DIFFCHANGE_TIMESPAN = 1209600),
          (e.MAX_BLOCK_WEIGHT = 4e6),
          (e.MIN_TRANSACTION_WEIGHT = 240),
          (e.WITNESS_SCALE_FACTOR = 4),
          (e.MAX_BLOCK_SIGOPS_COST = 8e4),
          (e.PUBKEY_ADDRESS_PREFIX_MAIN = 0),
          (e.SCRIPT_ADDRESS_PREFIX_MAIN = 5),
          (e.PUBKEY_ADDRESS_PREFIX_TEST = 111),
          (e.SCRIPT_ADDRESS_PREFIX_TEST = 196),
          (e.MAX_SCRIPT_ELEMENT_SIZE = 520),
          (e.SUBSIDY_HALVING_INTERVAL = 21e4),
          (e.MAX_SCRIPTNUM_VALUE = 2147483648),
          (e.COINBASE_MATURITY = 100),
          (e.EPOCH_SATS = [
            0n,
            1050000000000000n,
            1575000000000000n,
            1837500000000000n,
            1968750000000000n,
            2034375000000000n,
            2067187500000000n,
            2083593750000000n,
            2091796875000000n,
            2095898437500000n,
            2097949218750000n,
            2098974609270000n,
            2099487304530000n,
            2099743652160000n,
            2099871825870000n,
            2099935912620000n,
            2099967955890000n,
            2099983977420000n,
            2099991988080000n,
            2099995993410000n,
            2099997995970000n,
            2099998997250000n,
            2099999497890000n,
            2099999748210000n,
            2099999873370000n,
            2099999935950000n,
            2099999967240000n,
            2099999982780000n,
            2099999990550000n,
            2099999994330000n,
            2099999996220000n,
            2099999997060000n,
            2099999997480000n,
            2099999997690000n,
          ]);
      },
      740: (t, e) => {
        Object.defineProperty(e, "__esModule", { value: !0 }),
          (e.DecimalSat = void 0);
        class r {
          height;
          offset;
          constructor(t, e) {
            (this.height = t), (this.offset = e);
          }
          static fromSat(t) {
            return new r(t.height(), t.third());
          }
          toString() {
            return `${this.height.toString()}.${this.offset.toString()}`;
          }
        }
        e.DecimalSat = r;
      },
      472: (t, e, r) => {
        Object.defineProperty(e, "__esModule", { value: !0 });
        const n = r(324);
        class i {
          hour;
          minute;
          second;
          third;
          constructor(t, e, r, n) {
            (this.hour = t),
              (this.minute = e),
              (this.second = r),
              (this.third = n);
          }
          toString() {
            return `${this.hour}°${this.minute}′${this.second}″${this.third}‴`;
          }
          static fromSat(t) {
            const e = t.height().n(),
              r = Math.floor(
                Number(e / (n.CYCLE_EPOCHS * n.SUBSIDY_HALVING_INTERVAL))
              ),
              o = Number(e % n.SUBSIDY_HALVING_INTERVAL),
              a = Number(e % n.DIFFCHANGE_INTERVAL),
              s = t.third();
            return new i(r, o, a, s);
          }
        }
        e.default = i;
      },
      664: function (t, e, r) {
        var n =
          (this && this.__importDefault) ||
          function (t) {
            return t && t.__esModule ? t : { default: t };
          };
        Object.defineProperty(e, "__esModule", { value: !0 }),
          (e.fromHeightToEpoch = e.fromSatToEpoch = void 0);
        const i = r(324),
          o = n(r(868)),
          a = n(r(824));
        class s {
          static FIRST_POST_SUBSIDY = new s(33);
          epoch;
          constructor(t) {
            this.epoch = t;
          }
          n() {
            return this.epoch;
          }
          static STARTING_SATS() {
            return i.EPOCH_SATS.map((t) => new a.default(t));
          }
          subsidy() {
            return this.lt(s.FIRST_POST_SUBSIDY)
              ? BigInt(50n * i.COIN_VALUE) >> BigInt(this.epoch)
              : 0n;
          }
          startingSat() {
            const t = Math.min(this.epoch, s.STARTING_SATS().length - 1);
            return s.STARTING_SATS()[t];
          }
          startingHeight() {
            return new o.default(this.epoch * i.SUBSIDY_HALVING_INTERVAL);
          }
          equals(t) {
            return this.epoch === t;
          }
          lt(t) {
            return this.epoch < t.epoch;
          }
        }
        (e.default = s),
          (e.fromSatToEpoch = function (t) {
            const e = s.STARTING_SATS().findIndex((e) => t.lt(e));
            return new s(-1 === e ? 33 : e - 1);
          }),
          (e.fromHeightToEpoch = function (t) {
            return new s(Math.floor(t.n() / i.SUBSIDY_HALVING_INTERVAL));
          });
      },
      868: (t, e, r) => {
        Object.defineProperty(e, "__esModule", { value: !0 });
        const n = r(324),
          i = r(664);
        class o {
          height;
          constructor(t) {
            this.height = t;
          }
          n() {
            return this.height;
          }
          toString() {
            return this.height.toString();
          }
          subsidy() {
            return (0, i.fromHeightToEpoch)(this).subsidy();
          }
          startingSat() {
            const t = (0, i.fromHeightToEpoch)(this),
              e = t.startingSat(),
              r = t.startingHeight();
            return e.add(BigInt(this.n() - r.n()) * t.subsidy());
          }
          periodOffset() {
            return this.height % n.DIFFCHANGE_INTERVAL;
          }
          add(t) {
            return new o(this.height + t);
          }
          sub(t) {
            return new o(this.height - t);
          }
          equals(t) {
            return this.height === t;
          }
        }
        e.default = o;
      },
      824: function (t, e, r) {
        var n =
          (this && this.__importDefault) ||
          function (t) {
            return t && t.__esModule ? t : { default: t };
          };
        Object.defineProperty(e, "__esModule", { value: !0 });
        const i = r(324),
          o = r(740),
          a = n(r(472)),
          s = r(664),
          h = r(796);
        class u {
          static LAST = new u(i.SAT_SUPPLY - 1n);
          value;
          constructor(t) {
            this.value = t;
          }
          add(t) {
            return new u(this.value + t);
          }
          addAssign(t) {
            this.value += t;
          }
          lt(t) {
            return this.value < t.value;
          }
          n() {
            return this.value;
          }
          decimal() {
            return new o.DecimalSat(this.height(), this.third());
          }
          rarity() {
            const t = (0, h.rarityFromSat)(this);
            return h.Rarity[t];
          }
          rarityEmoji() {
            const t = this.rarity();
            let e = h.RarityEmojiType.Common;
            return (
              t == h.Rarity.Mythic
                ? (e = h.RarityEmojiType.Mythic)
                : t == h.Rarity.Legendary
                ? (e = h.RarityEmojiType.Legendary)
                : t == h.Rarity.Epic
                ? (e = h.RarityEmojiType.Epic)
                : t == h.Rarity.Rare
                ? (e = h.RarityEmojiType.Rare)
                : t == h.Rarity.Uncommon && (e = h.RarityEmojiType.Uncommon),
              e
            );
          }
          rarityColor() {
            const t = this.rarity();
            let e = h.RarityColorType.Common;
            return (
              t == h.Rarity.Mythic
                ? (e = h.RarityColorType.Mythic)
                : t == h.Rarity.Legendary
                ? (e = h.RarityColorType.Legendary)
                : t == h.Rarity.Epic
                ? (e = h.RarityColorType.Epic)
                : t == h.Rarity.Rare
                ? (e = h.RarityColorType.Rare)
                : t == h.Rarity.Uncommon && (e = h.RarityColorType.Uncommon),
              e
            );
          }
          degree() {
            return a.default.fromSat(this);
          }
          height() {
            let t = this.epoch(),
              e = Number(this.epochPosition() / t.subsidy());
            return t.startingHeight().add(e);
          }
          cycle() {
            const t = this.epoch().epoch;
            return Math.floor(t / i.CYCLE_EPOCHS);
          }
          nineball() {
            let t = this.n();
            return t >= 50n * i.COIN_VALUE * 9n && t < 50n * i.COIN_VALUE * 10n;
          }
          percentile() {
            const t = (this.value * BigInt(1e32)) / u.LAST.value;
            if (0n == t) return "0%";
            if (t / BigInt(1e30)) {
              const e = (Number(t) / 1e30).toFixed(12);
              return `${e.substring(0, e.length - 2)}%`;
            }
            {
              const e = (Number(t) / 1e30).toFixed(22);
              return `${e.substring(0, e.length - 2)}%`;
            }
          }
          epoch() {
            return (0, s.fromSatToEpoch)(this);
          }
          period() {
            return Math.floor(this.height().n() / i.DIFFCHANGE_INTERVAL);
          }
          third() {
            return this.epochPosition() % this.epoch().subsidy();
          }
          epochPosition() {
            return this.value - this.epoch().startingSat().n();
          }
          timestamp(t) {
            const e = this.height().n();
            if (t > e) return "";
            const r = 600 * (e - t),
              n = Date.now() + 1e3 * r;
            return new Date(n).toISOString() + "(expected)";
          }
          name() {
            let t = i.SAT_SUPPLY - this.value,
              e = "";
            for (; t > 0n; ) {
              (e += "abcdefghijklmnopqrstuvwxyz"[Number((t - 1n) % 26n)]),
                (t = (t - 1n) / 26n);
            }
            return e.split("").reverse().join("");
          }
          static fromName(t) {
            let e = 0n;
            for (const r of t) {
              if (!(r >= "a" && r <= "z"))
                throw new Error(`invalid character in sat name: ${r}`);
              if (
                ((e =
                  26n * e + BigInt(r.charCodeAt(0) - "a".charCodeAt(0)) + 1n),
                e > i.SAT_SUPPLY)
              )
                throw new Error("sat name out of range");
            }
            return new u(i.SAT_SUPPLY - e);
          }
          static fromSat(t) {
            if (!t.match(/^[0-9]+$/)) throw new Error("Invalid sat format");
            const e = BigInt(t);
            if (e > i.SAT_SUPPLY) throw new Error("Invalid sat");
            return new u(e);
          }
        }
        e.default = u;
      },
      796: (t, e) => {
        var r, n, i;
        Object.defineProperty(e, "__esModule", { value: !0 }),
          (e.rarityFromSat =
            e.RarityEmojiType =
            e.RarityColorType =
            e.Rarity =
              void 0),
          (function (t) {
            (t.Mythic = "Mythic"),
              (t.Legendary = "Legendary"),
              (t.Epic = "Epic"),
              (t.Rare = "Rare"),
              (t.Uncommon = "Uncommon"),
              (t.Common = "Common");
          })(r || (e.Rarity = r = {})),
          (function (t) {
            (t.Mythic = "#f2a900"),
              (t.Legendary = "#ffd700"),
              (t.Epic = "#9932cc"),
              (t.Rare = "#6495ed"),
              (t.Uncommon = "#228b22"),
              (t.Common = "#808080");
          })(n || (e.RarityColorType = n = {})),
          (function (t) {
            (t.Mythic = "👑"),
              (t.Legendary = "🌝"),
              (t.Epic = "🪻"),
              (t.Rare = "🧿"),
              (t.Uncommon = "🌱"),
              (t.Common = "🪙");
          })(i || (e.RarityEmojiType = i = {})),
          (e.rarityFromSat = function (t) {
            const { hour: e, minute: n, second: i, third: o } = t.degree();
            return 0 === e && 0 === n && 0 === i && 0n === o
              ? r.Mythic
              : 0 === n && 0 === i && 0n === o
              ? r.Legendary
              : 0 === n && 0n === o
              ? r.Epic
              : 0 === i && 0n === o
              ? r.Rare
              : 0n === o
              ? r.Uncommon
              : r.Common;
          });
      },
      880: function (t, e, r) {
        var n =
          (this && this.__importDefault) ||
          function (t) {
            return t && t.__esModule ? t : { default: t };
          };
        Object.defineProperty(e, "__esModule", { value: !0 });
        const i = r(324),
          o = n(r(472)),
          a = n(r(664)),
          s = r(796);
        e.default = class {
          value;
          constructor(t) {
            this.value = t > i.SAT_LAST ? i.SAT_LAST : t;
          }
          rarity() {
            const t = (0, s.rarityFromSat)(this);
            return s.Rarity[t];
          }
          rarityEmoji() {
            const t = this.rarity();
            let e = s.RarityEmojiType[s.Rarity.Common],
              r = s.RarityColorType[s.Rarity.Common];
            return (
              (t == s.Rarity.Mythic ||
                t == s.Rarity.Legendary ||
                t == s.Rarity.Epic ||
                t == s.Rarity.Rare ||
                t == s.Rarity.Uncommon) &&
                ((e = s.RarityEmojiType[t]), (r = s.RarityColorType[t])),
              { rarity: t, emoji: e, color: r }
            );
          }
          degree() {
            return o.default.fromSat(this);
          }
          height() {
            let t = this.epoch(),
              e = t.subsidy(),
              r = Number(this.epochPosition() / e);
            return t.startingHeight().add(r);
          }
          cycle() {
            const t = this.epoch().epoch;
            return Math.floor(t / i.CYCLE_EPOCHS);
          }
          epoch() {
            const t = a.default
              .STARTING_SATS()
              .findIndex((t) => this.value < t.value);
            return new a.default(-1 === t ? 33 : t - 1);
          }
          period() {
            return Math.floor(this.height().n() / i.DIFFCHANGE_INTERVAL);
          }
          third() {
            return this.epochPosition() % this.epoch().subsidy();
          }
          epochPosition() {
            return this.value - this.epoch().startingSat().n();
          }
        };
      },
    },
    e = {};
  var r = (function r(n) {
    var i = e[n];
    if (void 0 !== i) return i.exports;
    var o = (e[n] = { exports: {} });
    return t[n].call(o.exports, o, o.exports, r), o.exports;
  })(880);
  return r;
};

export default satBox;
